import { ProjectModule } from "@/store/modules/project.module";
import { Machine } from "xstate";
const projectImpedimentMachine = Machine({
    id: "projectImpediment",
    initial: "idle",
    states: {
        idle: {
            always: {
                target: "modalDormant",
            },
        },
        modalDormant: {
            on: {
                GET_IMPEDIMENTS: { target: "modalActive" },
            },
        },
        modalActive: {
            initial: "gettingImpediments",
            on: {
                MAKE_MODAL_DORMANT: { target: "modalDormant" },
            },
            states: {
                gettingImpediments: {
                    invoke: {
                        id: "gettingImpediments",
                        src: (context, event) => {
                            return ProjectModule.GetProjectImpediments(event.projectId);
                        },
                        onDone: { target: "loadedImpediments" },
                        onError: { target: "loadedImpediments" },
                    },
                },
                loadedImpediments: {
                    on: {
                        POST_IMPEDIMENT: { target: "postImpediment" },
                        RESOLVE_IMPEDIMENT: { target: "resolveImpediment" },
                        DELETE_IMPEDIMENT: { target: "deleteImpedient" },
                    },
                },
                postImpediment: {
                    invoke: {
                        id: "postImpediment",
                        src: (context, event) => {
                            return ProjectModule.AddImpedimentsToProject(event.payload);
                        },
                        onDone: { target: "loadedImpediments" },
                        onError: { target: "#projectImpediment.serviceUnavailable" },
                    },
                },
                resolveImpediment: {
                    invoke: {
                        id: "resolveImpediment",
                        src: (context, event) => {
                            return ProjectModule.ResolveImpediment(event.impedimentId);
                        },
                        onDone: { target: "loadedImpediments" },
                        onError: { target: "#projectImpediment.serviceUnavailable" },
                    },
                },
                deleteImpedient: {
                    tags: "showDeleteImpedimentUI",
                    on: {
                        DELETING_IMPEDIMENT: { target: "deletingImpedient" },
                        CLOSE_MODAL: { target: "loadedImpediments" },
                    },
                },
                deletingImpedient: {
                    tags: "showDeleteImpedimentUI",
                    invoke: {
                        id: "deletingImpedient",
                        src: (context, event) => {
                            return ProjectModule.DeleteImpediment(event.impedimentId);
                        },
                        onDone: { target: "loadedImpediments" },
                        onError: { target: "#projectImpediment.serviceUnavailable" },
                    },
                },
            },
        },
        serviceUnavailable: { type: "final" },
    },
}, {
    actions: {},
});
export default projectImpedimentMachine;
